import { useEffect } from 'react'
import { ProjectWrapper, LinkButton } from '../../GlobalStyles'
import { ViewAllProjects } from '../../components/ViewAllProjects'
import { Carousel } from '../../components/Carousel'
import wave from '../../assets/white-wave.svg'

import image1 from '../../assets/budgie/login.png'
import image2 from '../../assets/budgie/accounts.png'
import image3 from '../../assets/budgie/transactions.png'
import image4 from '../../assets/budgie/budget.png'
import image5 from '../../assets/budgie/goals.png'
import image6 from '../../assets/budgie/insights-top.png'
import image7 from '../../assets/budgie/insights-bottom.png'

export const Budgie = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const projectImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
  ]

  return (
    <ProjectWrapper>
      <div className='banner' style={{ background: 'linear-gradient(to right, #DCE2F7, #5374DA)' }}>
        <img src={wave} alt='decorative wave' />
      </div>

      <section className='description'>
        <h1 className='title'>[ <b>Budgie</b> ]</h1>
        <div className='summary'>
          <p className='type'>Full Stack Development, Web App</p>
          <p className='duration'>Collaborative Project • 2024</p>
        </div>

        <div className='details'>
          <p>
            Budgie is a personal finance platform built to replace Mint, offering comprehensive tracking of budgets, expenses, and savings goals with enterprise-grade reliability.
          </p>
          <p>
            Users can safely onboard multiple accounts (assets & liabilities), log transactions, categorize spending, and configure both one-off and recurring budgets. Advanced goal management lets you allocate funds by priority or target date.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <Carousel images={projectImages} />
        </div>

        <div className='details'>
          <p>
            Architected with TypeScript, Vite & React on the frontend, leveraging React Query for efficient data caching. Backend services use Node.js, Express & Prisma against PostgreSQL, while Styled Components and Ant Design ensure a polished, consistent UI.
          </p>
          <p>
            Collaborated with an analytics expert to embed data-driven insights, enabling users to visualize spending trends and forecast financial health.
          </p>
        </div>

        <div className='details'>
          <p>
            Explore the full codebase and documentation on{' '}
            <a href='https://github.com/v-prt/budgie' target='_blank' rel='noopener noreferrer'>
              GitHub
            </a>.
          </p>
          <p>
            <b>Tech stack:</b> TypeScript · Vite · React · React Query · Node.js · Express · Prisma · PostgreSQL · Ant Design · Styled Components · npm Workspaces
          </p>
          <div className='buttons'>
            <LinkButton
              className='white'
              href='https://github.com/v-prt/budgie'
              target='_blank'
              rel='noopener noreferrer'
            >
              View on GitHub
            </LinkButton>
          </div>
        </div>
      </section>
      <ViewAllProjects />
    </ProjectWrapper>
  )
}
